import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AuthService } from '../../../auth.service';
import { ToastrService } from 'ngx-toastr';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox'; // Import MatCheckboxModule

@Component({
  selector: 'app-add-role-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    CommonModule,
    MatProgressBarModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule, // Include MatCheckboxModule
  ],
  templateUrl: './add-role-dialog.component.html',
  styleUrls: ['./add-role-dialog.component.css'], // Corrected property name
})
export class AddRoleDialogComponent implements OnInit {
  registerForm: FormGroup = new FormGroup({});
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddRoleDialogComponent>,
    private authService: AuthService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.registerForm = this.fb.group({
      role: ['', Validators.required],
      isAdmin: [false], // Add isAdmin to the form
    });
  }

  register(): void {
    if (this.registerForm.invalid) {
      return;
    }
    const role = this.registerForm.get('role')?.value
    const isAdmin = this.registerForm.get('isAdmin')?.value
    this.isLoading = true;
    this.authService.addRole(role, isAdmin).subscribe({
      next: (response: any) => {
        this.toastr.success('Role added successfully!', 'Success');
        this.dialogRef.close(this.registerForm.value);
        this.isLoading = false;
      },
      error: (error: any) => {
        this.isLoading = false;
        this.toastr.error('Failed to add role. Please try again.', 'Error');
      },
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
